import { VERSION } from './version'

export const environment = {
  production: true,
  PAPI: window['environment'].PAPI,
  API: window['environment'].API,
  WS: window['environment'].WS,
  sentry: window['environment'].sentry,
  version: VERSION,
}
